import React, { useState,useEffect } from "react";
import Logo from "../../Assests/Images/tfs_logo.png";
import styles from "./CreateAccount.module.scss";
import Card from "../../Components/Atoms/Card/Card";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import {
  FormDropdown,
  FormField,
  FormFieldMail,
} from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PrimaryButton } from "../../Components/Atoms/Button/Button";
import { useNavigate } from "react-router-dom";
import OtpInput from "../../Components/Atoms/OtpInput/OtpInput";
import { FaTemperatureHigh } from "react-icons/fa";

import {get_master_data,signup_customer,verify_otp} from "../../Enums/api_constunts"
import _ from "lodash"
import {postMethod} from "../../Helpers/services"
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
import { useParams,useLocation } from 'react-router-dom';

export default function CreateAccount() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tenant_id = searchParams.get('tenant_id');
  const [isSpinner, setIsSpinner] = useState(false);
  const [isOtpField, setOtpField] = useState(false);
  const [isServiceEnable, setIsServiceEnable] = useState(false);
  const [serviceTypes,setServiceTypes] = useState([])
  const [selectedServiceType, setSelectedServiceType] = useState(null)
  const [newUser, setNewUser] = useState(null)

  const [selected_plan, setSelected_plan] = useState(null)
    const [subscription_plans, set_subscription_plans] = useState([])

  const getMasterData = ()=>{
    let postData = {"categories":["md_service_types","md_subscription_plans"]};
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      

     let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
        item["label"] =  item["name"]
        
        return item
      });
      setServiceTypes(md_service_types)

      if(_.get(res,"result.md_subscription_plans.length",0)>0){ 
        let md_service_types =   _.get(res,"result.md_subscription_plans",[]).map((item)=>{
           item["label"] =  item["name"]
           
           return item
         });
         set_subscription_plans(md_service_types)
       }
      
    })
  }

  useEffect(()=>{
    getMasterData()
  },[]);

  const handleSendOtp = (values) => {
   

  };

  const handleSubmit = (data) => {
    console.log(JSON.stringify(data))
    setIsSpinner(true);
    let postData = {...data};
    if(_.get(selectedServiceType,"id",false)){
      postData["service_type_id"] = selectedServiceType["id"]
    }
    if(tenant_id && tenant_id>0){
      postData["tenant_id"] = tenant_id
    }
    if(_.has(postData,"mobile_no")){
      let mobile_no  = postData["mobile_no"].trim()
      if (mobile_no.startsWith("+91-")) {
        
      } else {
        mobile_no = `+91-${mobile_no}`;
      }
      postData["mobile_no"] =  mobile_no;

    }
    postMethod(signup_customer,postData).then((res)=>{
      setNewUser(res.result)
      setIsSpinner(false);
      setOtpField(true);
      showToast("success",_.get(res, "message","Success"))
     }).catch((error)=>{
      
      
      if(_.get(error, "code") =="SIGNUP_VERIFICATION_PENDING"){
        setOtpField(true);
        if(_.get(error, "result.user_id") ){
          setNewUser(error["result"])
        }
      }
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

     })
  };
  
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      service: "",
      //confirmPassword: "",
      mobile_no: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required")
      .min(2, "Must be at least 2 characters")
      .max(50, "Must be 50 characters or less"),
      last_name: Yup.string()
          .required("Last name is required")
          .min(1, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
      email: Yup.string().email("Invalid email address")
      .required("Email is required")
      .min(2, "Must be at least 2 characters")
      .max(50, "Must be 50 characters or less"),
      mobile_no: Yup.string().required("Please enter your mobile number"),
      service: Yup.string().required("Please select service"),
    }),
    onSubmit: handleSubmit,
  });



  const handleOTPComplete = (otp='') => {
    
    let postData = { "user_id":0,  "otp":otp}
    postData["user_id"] = _.get(newUser,"user_id")

    postMethod(verify_otp,postData).then((res)=>{
      setNewUser(null)
      setIsSpinner(false);
      setOtpField(false);
      showToast("success",_.get(res, "message","Success"))
      navigateTo("/")
     }).catch((error)=>{
      
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

     })
  };

  const handleCloseModal = () => {
    setIsSpinner(false);
    setIsServiceEnable(false);
    setOtpField(false);
  };
  const handleKeyDown = (event) => {
    
    if (event.key === 'Enter') {
      
      formik.handleSubmit()
      
    }
  };

  return (
    <div className={styles.outer_container}>
      <div>
        {/* <div className="d-flex justify-content-between align-items-center bg-light position-absolute">
          <img src={Logo} alt="logo" height="70px" />
        </div> */}
       
        <div className={styles.create_account}>
          <div className={styles.create_account_container}>
            <Card className={styles.cardDetails}>
              <div className="text-center">
                <img src={Logo} alt="logo" height="70px" />
                <p className="d-flex flex-column mt-1">
                  <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
                    Welcome To TFS
                  </span>
                  {/* <span className="fs-6 lh-1 mt-3">Welcome back!</span> */}
                </p>
              </div>
              {/* <p className="d-flex flex-row mt-1 text-center justify-content-center">
                <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
                  Create an account
                </span>
              </p> */}
              <div className="d-flex flex-column justify-content-center align-items-center mt-3">
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="First Name"
                    id="first_name"
                    name="first_name"
                    type="text"
                    value={formik.values.first_name}
                    onChange={(e) =>
                      formik.setFieldValue("first_name", e.target.value)
                    }
                    error={formik.touched.first_name && formik.errors.first_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.first_name && <ErrorLabel
                    name="first_name"
                    formik={formik}
                    message={formik.errors.first_name}
                  />}
                </div>
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Last Name"
                    id="last_name"
                    name="last_name"
                    type="text"
                    value={formik.values.last_name}
                    onChange={(e) =>
                      formik.setFieldValue("last_name", e.target.value)
                    }
                    error={formik.touched.last_name && formik.errors.last_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.last_name && <ErrorLabel
                    name="last_name"
                    formik={formik}
                    message={formik.errors.last_name}
                  />}
                </div>
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Email Address"
                    id="email"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    error={formik?.touched.email && formik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.email && <ErrorLabel
                    name="email"
                    formik={formik}
                    message={formik.errors.email}
                  />}
                </div>
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={formik.values.mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={formik.touched.mobile_no && formik.errors.mobile_no}
                    disableNumbers={false}
                    disableAlphebets={true}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.mobile_no && <ErrorLabel
                    name="mobile_no"
                    formik={formik}
                    message={formik.errors.mobile_no}
                  />}
                </div>
                
                  <div className="mb-2" onKeyDown={handleKeyDown}>
                    <FormDropdown
                      id="service"
                      name="service"
                      label="Services"
                      options={serviceTypes}
                      onChange={(selected) => {
                        setSelectedServiceType(selected)
                        formik.setFieldValue("service", selected?.id);
                        setSelected_plan(null);
                        formik.setFieldValue("current_plan_id", null);
                      }}
                      isImportant={true}
                      value={formik.values.service}
                      error={formik.touched.service && formik.errors.service}
                      onBlur={formik.handleBlur}
                      className={styles.formField}
                    />
                    {formik.touched.service && <ErrorLabel
                      name="service"
                      formik={formik}
                      message={formik.errors.service}
                    />}
                  </div>

                  {
                  _.has(selectedServiceType,"id") && _.get(selectedServiceType,"id",null)==1 && <div className="mb-2" onKeyDown={handleKeyDown}>
                    <FormDropdown
                     id="selectedPlan"
                     name="selectedPlan"
                     label="Select Plan"
                     options={subscription_plans}
                      onChange={(selected) => {
                        setSelected_plan(selected);
                        formik.setFieldValue("current_plan_id", selected?.id);
                      }}
                      isImportant={true}
                      value={formik.values.current_plan_id}
                      error={formik.touched.current_plan_id && formik.errors.current_plan_id}
                      onBlur={formik.handleBlur}
                      className={styles.formField}
                    />
                    {formik.touched.current_plan_id && <ErrorLabel
                      name="service"
                      formik={formik}
                      message={formik.errors.current_plan_id}
                    />}
                  </div>
                  }
                 
                
                {isOtpField && (
                  <OtpInput
                    isModalOpen={true}
                    handleClose={handleCloseModal}
                    numInputs={6}
                    onComplete={handleOTPComplete}
                    separator=" "
                    isNumeric={true}
                    otpStatus={"error"}
                    spinner={false}
                   // handleResendOtp={handleOTPComplete}
                  />
                )}
              </div>
              <div className="text-center">
                
                  <PrimaryButton
                    label="Submit"
                    className={styles.otpButton}
                    onClick={formik.handleSubmit}
                    disabled={!(formik.dirty && formik.isValid)}
                    spinner={isSpinner}
                  />
                
              </div>
              <p
                className={`fs-3 lh-1 fw-bold text-center ${styles.logintext}`}
                onClick={() => navigateTo("/customer-login")}
              >
                Back to Login
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}


